const getTrimmedUrl = () => {
  let uri = window.location.href;
  if (uri.indexOf('#') > 0) {
    return uri.substring(0, uri.indexOf('#'));
  }
  return uri;
};

export default getTrimmedUrl;
